<template>
  <div class="spinner" :class="{'spinner-disabled': disabled}">
    <input :disabled="disabled" type="text" :class="{disabled: true}" :value="displayValue" @focus="$event.target.select()" @change="updateValue($event.target.value)" @blur="handleBlur($event.target.value)" class="form-control" ref='input' :min='min' :step='step' :max='max' @keydown.up.prevent='arrowUp' @keydown.down.prevent='arrowDown' />
    <div class="spinner-button spinner-up" :class="{'spinner-button-disabled': disabled}" @click="arrowUp" href="#">
      <i class="fa fa-sort-up spinner-icon-up"></i>
    </div>
    <div class="spinner-button spinner-down" :class="{'spinner-button-disabled': disabled}" @click="arrowDown" href="#">
      <i class="fa fa-sort-down spinner-icon-down"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: [Number, String],
    minSize: [Number, String],
    maxSize: [Number, String],
    stepSize: [Number, String],
    fixedSize: [Number, String],
    displayPlus: { type: [Boolean, String], default: false },
    disabled: false,
    roundToStepSize: { type: Boolean, default: true },
    defaultNegative: { type: [Boolean, String], default: false },
    inputName:[String, String]
  },
  data() {
    return {
      numericValue: undefined,
      positiveValue:false,
      isArrowUp:false,
      isArrowDown:false
    };
  },
  created() {
    if (this.value !== undefined && this.value !== "" && this.value !== null) {
      this.numericValue = Number(this.value);
    }
  },
  methods: {
    arrowUp() {
      if (!this.disabled) {
        this.numericValue = this.numericValue || 0;
        this.isArrowUp = true;
        this.isArrowDown = true;
        this.handleChange(this.numericValue + this.step);
      }
    },
    arrowDown() {
      if (!this.disabled) {
        this.numericValue = this.numericValue || 0;
        this.isArrowUp = true;
        this.isArrowDown = true;
        this.handleChange(this.numericValue - this.step);
      }
    },
    updateValue(val) {
      this.handleChange(val);
    },
    handleBlur(val) {
      this.handleChange(val);
    },
    handleChange(val) {
      if (val === "" || isNaN(val)) {
        this.$refs.input.value = "";
        this.$emit("input", null);
        this.numericValue = undefined;
        return;
      }
      if(!this.isArrowUp && !this.isArrowDown){
         this.positiveValue = val.includes("+",0);
      }
      else
      {
        this.isArrowUp = false;
        this.isArrowDown = false;
      }
      var unrounded = Math.min(Math.max(val, this.min), this.max);

      if (this.roundToStepSize) {
        unrounded = Math.ceil(unrounded / this.step) * this.step;
      }
      this.numericValue = unrounded;

      this.$refs.input.value = this.displayValue;
      this.$emit("input", this.displayValue);
    }
  },

  computed: {
    displayValue() {
      if (this.numericValue === undefined) {
        return null;
      }

      var tempObject = JSON.parse(localStorage.getItem("orderObj")); 

      if(tempObject.ReCyl != null && tempObject.LeCyl !=null){
        if((this.inputName=="ReCyl" &&  tempObject.ReCyl.includes("+",0))
          || (this.inputName=="LeCyl" && tempObject.LeCyl.includes("+",0)))
        {
          this.positiveValue = true;
        }
      }
      var proposed = this.numericValue.toFixed(this.fixed);

      if(!this.positiveValue){
        if (proposed > 0 && this.displayPlus) {
          return "+" + proposed;
        } else if (proposed > 0 && this.defaultNegative) {
          var temp = -this.numericValue;
          return temp.toFixed(this.fixed);
        }
      }
      else
      {
          var temp =  this.numericValue.toFixed(this.fixed);
          if(temp.includes("-",0))
          {
            return temp;
          }
          else
          {
            return "+" + temp;
          }
      }
      return proposed;
    },
    step() {
      return Number(this.stepSize);
    },
    max() {
      return Number(this.maxSize);
    },
    min() {
      return Number(this.minSize);
    },
    fixed() {
      return Number(this.fixedSize);
    }
  }
};
</script>
<style>
.spinner-disabled {
  opacity: 0.6;
}

.spinner {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.spinner-button {
  position: absolute;
  right: 0;
  color: #999;
  height: 19px;
  width: 33px;
}
.spinner-button-disabled {
  color: #a6a6a6;
  background-color: #ededed;
}

.spinner-up {
  top: 0;
}
.spinner-down {
  bottom: 0;
}
.spinner-icon-up {
  position: relative;
  top: 2px;
  left: 5;
}

.spinner-icon-down {
  color: #999;
  position: relative;
  top: -2px;
}
</style>



// WEBPACK FOOTER //
// RxInput.vue?1ca21a16